import i18n from 'i18next';

import da from './locales/da-DK/translation.json';
import de from './locales/de-DE/translation.json';
import en from './locales/en/translation.json';
import es from './locales/es-ES/translation.json';
import fi from './locales/fi-FI/translation.json';
import fr from './locales/fr-FR/translation.json';
import it from './locales/it-IT/translation.json';
import ja from './locales/ja-JP/translation.json';
import ko from './locales/ko-KR/translation.json';
import nb from './locales/nb-NO/translation.json';
import nl from './locales/nl-NL/translation.json';
import pl from './locales/pl-PL/translation.json';
import ptBR from './locales/pt-BR/translation.json';
import ptPT from './locales/pt-PT/translation.json';
import sv from './locales/sv-SE/translation.json';
import zh from './locales/zh-CN/translation.json';

import { initReactI18next } from 'react-i18next';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

const instance = i18n.createInstance();

instance
.use(initReactI18next)
.init({
  lng: 'en',
  returnNull: false,
  keySeparator: false,
  fallbackLng: 'en',
  react: {
    useSuspense: false,
  },
  resources: {
    'da': { translation: da },
    'dk': { translation: da },
    'da-dk': { translation: da },
    'de': { translation: de },
    'de-de': { translation: de },
    en: { translation: en },
    'fr': {translation: fr },
    'fr-fr': {translation: fr },
    'es': { translation: es },
    'es-es': { translation: es },
    'fi': { translation: fi },
    'fi-fi': { translation: fi },
    'it': { translation: it },
    'it-it': { translation: it },
    'ja': { translation: ja },
    'ja-jp': { translation: ja },
    'ko': { translation: ko },
    'kr': { translation: ko },
    'ko-kr': { translation: ko },
    'nb': { translation: nb },
    'no': { translation: nb },
    'nb-no': { translation: nb },
    'nl': { translation: nl },
    'nl-nl': { translation: nl },
    'pl': { translation: pl },
    'pl-pl': { translation: pl },
    'br': { translation: ptBR },
    'pt-br': { translation: ptBR },
    'pt': { translation: ptPT },
    'pt-pt': { translation: ptPT },
    'sv': { translation: sv },
    'sv-se': { translation: sv },
    'zh': { translation: zh },
    'cn': { translation: zh },
    'zh-cn': { translation: zh },
  },
});

export default instance;
